<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Konton</h1>

<div class="container">
    <div class="row">
        <div class="col">
            <mat-card class="compact">
                <mat-card-content>
                    <app-admin-accounts
                        (filterChanged)="updateQueryParameters($event)"
                        [query]="query"></app-admin-accounts>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>
